let allStores = [];
let map;
let markers = [];
let activeInfoWindow = null;

window.initStoreLocatorMap = function () {
  map = new google.maps.Map(document.getElementById("store-map"), {
    center: { lat: 52.1326, lng: 5.2913 },
    zoom: 7
  });

  loadStores();
};

function loadStores() {
  fetch("https://cdn.shopify.com/s/files/1/0994/6716/6043/files/Json_stores1_29-6-2026.json?v=1782716711")
    .then(response => response.json())
    .then(stores => {
      allStores = stores.filter(store => store.lat && store.lng);
      document.getElementById("store-count").innerText = "Voer een postcode of woonplaats in om winkels te zoeken.";
      document.getElementById("store-list").innerHTML = "";
    })
    .catch(error => {
      console.error("Store JSON loading error:", error);
    });
}

function renderStores(stores) {
  const list = document.getElementById("store-list");
  const count = document.getElementById("store-count");

  list.innerHTML = "";

  if (stores.length === 0) {
    count.innerText = "Geen winkels gevonden in de buurt.";
    return;
  }

  count.innerText = `${stores.length} winkels gevonden`;

  stores.forEach(store => {
    const item = document.createElement("div");
    item.className = "store-card";

    item.innerHTML = `
      <h3>${store.name || ""}</h3>
      <p>${store.address || ""}</p>
      <p>${store.zip || ""} ${store.city || ""}</p>
      ${store.distance ? `<p class="store-distance">${store.distance.toFixed(1)} km afstand</p>` : ""}
      ${store.hours ? `<button type="button" class="hours-btn">Zie openingstijden</button><div class="hours">${store.hours}</div>` : ""}
      ${store.phone ? `<p>Telefoon: ${store.phone}</p>` : ""}
      ${store.email ? `<p>Email: ${store.email}</p>` : ""}
      ${store.url ? `<a href="${store.url}" target="_blank" rel="noopener">Website</a>` : ""}
    `;

    item.addEventListener("click", function () {
      document.querySelectorAll(".store-card").forEach(card => card.classList.remove("active"));
      item.classList.add("active");
      focusStore(store);
    });

    const hoursButton = item.querySelector(".hours-btn");
    const hoursBox = item.querySelector(".hours");
    if (hoursButton && hoursBox) {
      hoursButton.addEventListener("click", function (e) {
        e.stopPropagation();
        hoursBox.classList.toggle("is-open");
      });
    }

    list.appendChild(item);
  });
}

function renderMarkers(stores) {
  markers.forEach(marker => marker.setMap(null));
  markers = [];

  stores.forEach(store => {
    if (!store.lat || !store.lng) return;

    const marker = new google.maps.Marker({
      position: { lat: Number(store.lat), lng: Number(store.lng) },
      map: map,
      title: store.name || "",
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: "#0b5d3b",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 10
      }
    });

    marker.addListener("click", function () { focusStore(store); });
    markers.push(marker);
  });
}

function focusStore(store) {
  if (!store.lat || !store.lng) return;

  map.setCenter({ lat: Number(store.lat), lng: Number(store.lng) });
  map.setZoom(14);

  if (activeInfoWindow) activeInfoWindow.close();

  activeInfoWindow = new google.maps.InfoWindow({
    content: `
      <div class="store-info-window">
        <strong>${store.name || ""}</strong><br>
        ${store.address || ""}<br>
        ${store.zip || ""} ${store.city || ""}
      </div>
    `
  });

  const marker = markers.find(m => {
    const p = m.getPosition();
    return p.lat() === Number(store.lat) && p.lng() === Number(store.lng);
  });

  if (marker) activeInfoWindow.open(map, marker);
}

function fitMapToStores(stores) {
  const bounds = new google.maps.LatLngBounds();
  let hasStores = false;

  stores.forEach(store => {
    if (!store.lat || !store.lng) return;
    bounds.extend({ lat: Number(store.lat), lng: Number(store.lng) });
    hasStores = true;
  });

  if (hasStores) {
    map.fitBounds(bounds);
  } else {
    map.setCenter({ lat: 52.1326, lng: 5.2913 });
    map.setZoom(7);
  }
}

function showNearbyStores(userLat, userLng) {
  const nearby = allStores
    .map(store => ({
      ...store,
      distance: getDistanceKm(userLat, userLng, Number(store.lat), Number(store.lng))
    }))
    .sort((a, b) => a.distance - b.distance)
    .slice(0, 10);

  renderStores(nearby);
  renderMarkers(nearby);
  fitMapToStores(nearby);
}

function geocodeAndSearch(query) {
  const isNLPostcode = /^\d{4}\s?[a-zA-Z]{0,2}$/.test(query);

  if (isNLPostcode) {
    // Nederlandse postcode via PDOK
    fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${encodeURIComponent(query)}&fq=type:postcode&rows=1`)
      .then(res => res.json())
      .then(data => {
        const centroid = data?.response?.docs?.[0]?.centroide_ll;
        const match = centroid?.match(/POINT\(([^ ]+) ([^ )]+)\)/);
        if (match) {
          showNearbyStores(parseFloat(match[2]), parseFloat(match[1]));
        } else {
          // Fallback: probeer zonder type filter
          fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${encodeURIComponent(query)}&rows=1`)
            .then(res => res.json())
            .then(data2 => {
              const c2 = data2?.response?.docs?.[0]?.centroide_ll;
              const m2 = c2?.match(/POINT\(([^ ]+) ([^ )]+)\)/);
              if (m2) {
                showNearbyStores(parseFloat(m2[2]), parseFloat(m2[1]));
              } else {
                document.getElementById("store-count").innerText = "Postcode niet gevonden.";
                document.getElementById("store-list").innerHTML = "";
              }
            });
        }
      })
      .catch(() => {
        document.getElementById("store-count").innerText = "Fout bij het zoeken. Probeer het opnieuw.";
      });

  } else {
    // Plaatsnaam: eerst PDOK, dan Nominatim als fallback
    fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${encodeURIComponent(query)}&fq=type:woonplaats&rows=1`)
      .then(res => res.json())
      .then(data => {
        const centroid = data?.response?.docs?.[0]?.centroide_ll;
        const match = centroid?.match(/POINT\(([^ ]+) ([^ )]+)\)/);
        if (match) {
          showNearbyStores(parseFloat(match[2]), parseFloat(match[1]));
        } else {
          // Niet in NL gevonden — probeer Nominatim (BE, DE, etc.)
          fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=5&accept-language=nl`)
            .then(res => res.json())
            .then(results => {
              const preferred = results.find(r =>
                ["city", "town", "village", "municipality"].includes(r.type) ||
                ["city", "town", "village", "municipality"].includes(r.addresstype)
              ) || results[0];

              if (preferred) {
                showNearbyStores(parseFloat(preferred.lat), parseFloat(preferred.lon));
              } else {
                document.getElementById("store-count").innerText = "Locatie niet gevonden. Probeer een andere plaatsnaam.";
                document.getElementById("store-list").innerHTML = "";
              }
            });
        }
      })
      .catch(() => {
        document.getElementById("store-count").innerText = "Fout bij het zoeken. Probeer het opnieuw.";
      });
  }
}

// Zoekknop
document.addEventListener("click", function (e) {
  if (e.target.id !== "store-search-btn") return;

  const query = document.getElementById("store-search").value.trim();
  if (!query) {
    document.getElementById("store-count").innerText = "Voer een postcode of woonplaats in.";
    document.getElementById("store-list").innerHTML = "";
    return;
  }

  document.getElementById("store-count").innerText = "Zoeken...";
  geocodeAndSearch(query);
});

// Enter-toets
document.addEventListener("keydown", function (e) {
  if (e.key === "Enter" && document.activeElement.id === "store-search") {
    document.getElementById("store-search-btn").click();
  }
});

// Gebruik mijn locatie
document.addEventListener("click", function (e) {
  if (e.target.id !== "use-location") return;

  if (!navigator.geolocation) {
    alert("Geolocatie wordt niet ondersteund door uw browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    position => {
      showNearbyStores(position.coords.latitude, position.coords.longitude);

      new google.maps.Marker({
        position: { lat: position.coords.latitude, lng: position.coords.longitude },
        map: map,
        title: "Uw locatie"
      });
    },
    error => {
      console.error("Geolocatie fout:", error);
      alert("Kan uw locatie niet ophalen.");
    }
  );
});

function getDistanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) *
    Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}



